<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="email-right-aside bookmark-tabcontent form theme-form datepicker-responsive">
            <div class="card">
                <div class="card-body" v-if="order.length > 0">
                    <div class="invoice text-align-last-left">
                        <div>
                            <div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="success-text">
                                            <p>{{ $t("lbl_EMPBE_TransactionId") }}: {{ order[0].eventSid }}</p>
                                            <p>{{ $t("lbl_EMPBE_PayDate") }}: {{ order[0].payDate }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <!-- End InvoiceTop-->
                            <div>
                                <div class="order-history success-table table-responsive">
                                    <table class="table table-bordernone">
                                        <thead>
                                            <tr>
                                                <th scope="col">{{ $t("lbl_EMPBE_Product") }}</th>
                                                <th class="text-align-last-right" scope="col">{{ $t("lbl_EMPBE_Price") }}
                                                </th>
                                                <th class="text-align-last-right" scope="col">{{ $t("lbl_EMPBE_Quantity") }}
                                                </th>
                                                <th class="text-align-last-right" scope="col">{{ $t("lbl_EMPBE_ExpiryDate")
                                                }}</th>
                                                <th class="text-align-last-right" scope="col">{{ $t("lbl_EMPBE_Subtotal") }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in order" :key="index">
                                                <td>
                                                    <div class="product-name">
                                                        {{ langid == '1252' ? item.titleEn : langid == '950' ? item.titleTc
                                                            :
                                                            item.titleSc }}
                                                    </div>
                                                </td>
                                                <td class="text-align-last-right">{{ item.currency == 840 ? 'USD$' : 'RMB¥'
                                                }}{{
    item.currency == 840 ? item.priceUSD : item.priceRMB }}</td>
                                                <td class="text-align-last-right">{{ item.qty }}</td>
                                                <td class="text-align-last-right">{{ item.expiryDate }}</td>
                                                <td class="text-align-last-right">{{ item.currency == 840 ? 'USD$' : 'RMB¥'
                                                }}{{
    item.currency == 840 ? item.priceUSD * item.qty : item.priceRMB *
    item.qty }}</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td class="Rate text-align-last-right">
                                                    <h6 class="mb-0">{{ $t("lbl_EMPBE_Total") }}</h6>
                                                </td>
                                                <td class="payment digits text-align-last-right">
                                                    <h6 class="mb-0">{{ order[0].currency == 840 ? 'USD$' : 'RMB¥' }}{{
                                                        order[0].amount }}</h6>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- End Table-->
                            </div>
                        </div>
                        <!-- End Invoice-->
                    </div>
                    <!-- Section ends -->
                </div>
            </div>
        </div>
    </b-overlay>
</template>
<script>

import { mapGetters, mapState } from 'vuex';
import { PaymentItemService } from '../../_services';

export default {
    components: {
    },
    data() {
        return {
            title: '',
            order: [],
            unsuccesfulCount: 0,
            Refcode: '',
            loading: false
        }
    },
    created() {
        this.GetPaymentByRefCodeOrEventSid();
        this.$watch(
            () => this.$route.params,
            (toParams, previousParams) => {
                this.GetPaymentByRefCodeOrEventSid();
                // react to route changes...

            }
        )
    },
    computed: {
        langid() {
            return localStorage.getItem("currentLangId")
        }
    },
    mounted() {
        this.unsuccesfulCount = 0
    },
    methods: {
        GetPaymentByRefCodeOrEventSid() {
            var that = this;
            that.loading = true;
            PaymentItemService.GetPaymentByRefCodeOrEventSid(this.Refcode, this.$route.params.id).then(res => {
                that.order = res;
                that.loading = false;
            })
        },

    }
};
</script>
<style>
.order-history table thead tr th,
.order-history table tbody tr td {
    padding: 0.75rem !important;
}

.text-align-last-right {
    text-align-last: right;
}

.text-align-last-left {
    text-align-last: left;
}
</style>